import { render, staticRenderFns } from "./DetailsActions.vue?vue&type=template&id=10b535f4&"
import script from "./DetailsActions.vue?vue&type=script&lang=js&"
export * from "./DetailsActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports